module.exports = __webpack_public_path__ + "static/media/trophy-alt.38f653fd.svg";